<template>
<div>

   <div class="disclaimer-box">
      <i class="fad fa-info-circle fa-2x disclaimer-icon"></i>
      <div
         v-for="dts in this.filteredDisclaimers"
         :key = dts.id
         class="disclaimer"
      >
         <div v-html="dts.text"></div>
      </div>
   </div>
</div>
</template>

<script>
   import { mapGetters, mapActions, mapState } from 'vuex'
   export default {
      props: {
         disclaimersToShow: Array,
      },
      computed: {
         ...mapState({
            disclaimers: state => state.global.disclaimers,
         }),
         filteredDisclaimers: function(){
            return this.disclaimers.filter(ds => this.disclaimersToShow.includes(ds.id))
         }
      }
   }
</script>

